import { RANK_TYPE } from '../../utils/enums';

export const EXPORT_COLORS = {
    navy: 'FF001937',
    bannerBlue: 'FF00B0F0',
    bannerFillerBlue: 'FF01B0F0',
    levelBlue: 'FF79D9FC',
    headingNavy: 'FF002060',
    black: 'FF000000',
    white: 'FFFFFFFF',
    titleGrey: 'FFF2F2F2',
    classAmber: 'FFFFEDBD',
    groupCream: 'FFFFFAEE',
    classGrey: 'FFDBE0E6',
    groupGrey: 'FFEDF1F4'
} as const;

export const ROW_STYLES = {
    class: {
        fill: EXPORT_COLORS.navy,
        font: EXPORT_COLORS.white,
        bold: true,
        dataFill: EXPORT_COLORS.classGrey
    },
    group: {
        fill: EXPORT_COLORS.classAmber,
        font: EXPORT_COLORS.navy,
        bold: true,
        dataFill: EXPORT_COLORS.groupGrey
    },
    student: {
        fill: EXPORT_COLORS.groupCream,
        font: EXPORT_COLORS.navy,
        bold: false,
        dataFill: EXPORT_COLORS.white
    },
    total: {
        fill: EXPORT_COLORS.white,
        font: EXPORT_COLORS.headingNavy,
        bold: true,
        dataFill: EXPORT_COLORS.white
    }
} as const;

export const EXPORT_FONT = 'Arial';

export const NAME_COLUMN_WIDTH = 62.33;
export const LEVEL_COLUMN_WIDTH = 15.66;
export const TOTAL_COLUMN_WIDTH = 30.66;

export const HEADER_ROW_COUNT = 5;

export const FROZEN_COLUMN_COUNT = 1;

export const ROW_HEIGHT = {
    title: 136.5,
    banner: 31.5,
    levelHeading: 24,
    data: 24,
    total: 48
} as const;

export const EXPORT_LEVELS: RANK_TYPE[] = [
    RANK_TYPE.bronze,
    RANK_TYPE.silver,
    RANK_TYPE.gold,
    RANK_TYPE.platinum,
    RANK_TYPE.emerald,
    RANK_TYPE.diamond,
    RANK_TYPE.epic,
    RANK_TYPE.legend
];

export const PAST_EXPORT_LEVELS: RANK_TYPE[] = [
    RANK_TYPE.bronze,
    RANK_TYPE.silver,
    RANK_TYPE.gold
];

export const LAST_COLUMN = 'J';
export const FIRST_LEVEL_COLUMN = 'B';

export const EMPTY_CELL = '-';
